import React from 'react';
import { Meetup } from '../../../../models/collection';
import MeetupsBlock from '../../../TravelCollection/MeetupsBlock';
import styled, { StylesProps } from '../../../../lib/styles';
import blockStyles from './Block_styles';
import { compose } from 'recompose';
import { Brand } from '../../../../lib/theme';

export interface MeetupBlockData {
  type: 'meetup_block';
}

interface MeetupBlockProps {
  meetups: Meetup[];
  brand: Brand;
}

const MeetupBlock = ({
  meetups,
  brand,
}: MeetupBlockProps & StylesProps<typeof blockStyles>) => {
  return <MeetupsBlock meetups={meetups} brand={brand} />;
};

export default compose(styled(blockStyles))(MeetupBlock);
